/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Коллекция для фильтров
   */
  app.Filters = {};
  app.Filters.Filters = app.Collection.extend({
    data: {},
    season: {},
    /**
     * Принудительный порядок сортировки фильтров
     */
    start: [
      'category',
      'price_filter',
    ],
    end: [
      'markers_filter',
      'items',
      'certificate_type',
      'agg_is_paid_delivery',
      'agg_supply_period',
      'supply_period'
    ],
    /**
     * Фильтры по шинам и дискам. Сгруппированные ключи расположены в порядке,
     * в котором они должны отобразиться.
     */
    tireAndWheelFilterKeys: [
      'car_filter',

      /* сгруппированные фильтры шин */
      'json_oot',
      'json_oor',
      'json_ooo',
      'json_fioo',
      'json_ftit',
      'json_fiot',
      'json_ooi',
      'json_oof',
      'by_count',

      /* сгруппированные фильтры дисков */
      'json_ooe',
      'json_oog',
      'json_oos',
      'json_otz',
      'json_ott',
      'json_otr',
      'json_oto',
      'json_oon',

      'json_rsgi',
      'tire_specification',
      'wheel_specification',

      /* фильтр runflat */
      'json_fost',

      /* фильтр торговых марок */
      'trademark',
    ],
    markersFilters: [
      'is_exclusive',
      'is_hit',
      'has_discount',
      'is_fast_delivery',
      'is_novelty',
      'is_wholesale',
      'has_rus_pack',
      'is_markdown',
    ],
    /**
     * Фильтр по возрасту.
     */
    ageFilter: 'json_oiif',
    requestFilterKeys: [],
    notEmphasizedFilters: ['agg_min_qty', 'certificate_type', 'agg_supply_period', 'min_qty', 'supply_period', 'items'],
    /**
     * @inheritDoc
     */
    initialize: function (models, options) {
      this.rangeNameTemplate = app.helpers.TemplateHelper.getTemplate('#range-name-template');
      this.itemsLabelTemplate = app.helpers.TemplateHelper.getTemplate('#items-label-template');
      this.hasTiresAndWheelsFilter = options && options.hasTiresAndWheelsFilter;
      this.isRootFilterPage = options && options.isRootFilterPage;
      this.itemCollection = options && options.itemCollection;
      // инициализируем состояние попапа с выбранными фильтрами
      this.chosenPopupState = {
        isOpen: false,
        sectionName: null,
      };
      this.total = new app.Filters.Total({
        count: 0,
        unit: app.helpers.DeclinationHelper.format(0, ['товар', 'товара', 'товаров']),
        selected: true,
      });
      this.listenTo(Backbone, 'chosen-popup-active', this.toggleChosenPopupState);
      this.listenTo(Backbone, 'clear-filters', this.clearData);
      if (app.filterData !== undefined) {
        this.setData(app.filterData);
      }
      this.filtersWrappedState = {};
    },
    /**
     * Очищаем данные фильтров.
     */
    clearData: function () {
      app.filterData = {};
      this.filtered = 0;
      this.setData(app.filterData);
      this.reset();
    },
    /**
     * Передача данных для построения фильтров.
     * @param {object} data Объект с данными для построения фильтров.
     */
    setData: function (data) {
      if (data) {
        this.collectTotalData(data);
        this.requestFilterKeys = _.keys(data);
        if (this.hasTiresAndWheelsFilter) {
          data = this.extractTiresWheelsFilters(data);
        }
        this.data = this.prepareData(data);
      }
    },

    /**
     * Оборачивает набор разрозненных фильтров в CompoundFilter и добавляет новый фильтр в исходные данные
     * @param data Исходные данные
     * @param props Список ключей фильтров, которые необходимо обернуть
     * @param key Новый ключ для добавления получившегося фильтра
     * @param params дополнительные параметры
     * @returns {Object} Обновленные данные
     */
    wrapData: function (data, props, key, params) {
      if (!_.isObject(params)) {
        params = {};
      }
      var filters = _.pick(data, props);
      params.class_name = 'ParamFilter';
      params.sub_filters = filters;
      data = _.omit(data, props);
      data[key] = params;
      return data;
    },

    /**
     * Дополняет данные для фильтров.
     * @param data Исходные данные
     * @returns {Object} Результирующие данные
     */
    prepareData: function (data) {
      var rangeProps = [],
        markersProps = [];
      if (this.isRootFilterPage && app.filterUrlParam) {
        var filterPageFilterKey = Object.keys(app.filterUrlParam)[0];
        delete data[filterPageFilterKey];
      }
      /**
       * Проверяем, есть ли среди пришедших фильтров фильтры для шин, дисков или спецификаций
       * и оборачиваем их в CompoundFilter
       */
      for (var e in data) {
        if (data.hasOwnProperty(e)) {
          // удаляем второй фильтр сезонности
          if (e === 'json_rent') {
            delete data[e];
            continue;
          }

          var unprefixed = _.replace(e, /agg_|json_/, '');
          if (this.markersFilters.indexOf(unprefixed) >= 0) {
            markersProps.push(e);
            continue;
          }

          if (_.includes(
            ['HasOne', 'HasMany', 'AggMinQty', 'AggSupplyPeriod', 'ColoredCheckboxList', 'AggRange', 'Range'],
            data[e].class_name)) {
            if (this.hasOneValue(data[e])) {
              delete data[e];
              continue;
            }
          }
          if (['AggRange', 'Range'].indexOf(data[e].class_name) !== -1) {
            rangeProps.push(e);
          }

          /**
           * Сохраняем данные по фильтрам для las-igras
           */
          if (e === this.ageFilter) {
            var ageFilters = _.groupBy(data[e].values, function (value) {
             return _.includes(value.name, '18') ? 'adult' : 'infant';
            });
            var filtersCount = _.reduce(ageFilters, function (acc, value, key) {
               acc[key] = _.sumBy(value, 'count');
               return acc;
            }, {});
            var filtersObjects = _.mapValues(ageFilters, function (value) {
              var filterObj = {};
              filterObj[e] =  _.map(value, 'id');
              return filterObj;
            });
            Backbone.trigger('las-igras-set-filter-data', filtersObjects, filtersCount);
          }
          // для указанных фильтров нужно отменить выделение
          if (_.includes(this.notEmphasizedFilters, e)) {
            data[e].data_type = 'not-option';
          }
        }
      }

      if (rangeProps.length) {
        for (var i = 0; i < rangeProps.length; i++) {
          e = rangeProps[i];
          var rangeParams = {
            htmlClass: e,
            name: e === 'price' ? data[e].name + ', ' + app.currentCurrency.grapheme : data[e].name,
            type: 'range',
            priority: data[e].priority,
            attr_tooltip: data[e].attr_tooltip
          };
          data = this.wrapData(data, e, e + '_filter', rangeParams);
        }
      }
      if (markersProps.length) {
        var markersParams = {
          htmlClass: 'markers',
          name: this.itemsLabelTemplate(),
        };
        data = this.wrapData(data, markersProps, 'markers_filter', markersParams);
      }
      this.setUniqueIdAndCountSelectedValues(data);
      return data;
    },

    /**
     * Выбираем из пришедших данных специфичные фильтры для блока выбора шин/дисков.
     * @param data
     */
    extractTiresWheelsFilters: function (data) {
      // убираем фильтр по шипам, если зимний сезон не выбран.
      if (data.json_ott && !_.find(data.json_ott.values, {
        selected: true,
        name: 'Зимние',
      })) {
        delete data.json_otr;
      }

      // Убираем runFlat если нет положительного фильтра
      if (data.json_fost && !_.find(data.json_fost.values, { id: '1' })) {
        delete data.json_fost;
      }

      var tiresAndWheelsFilters = _.pick(data, this.tireAndWheelFilterKeys);
      this.setUniqueIdAndCountSelectedValues(tiresAndWheelsFilters);
      // фильтры по авто, тип диска, сезонности, количеству и шипов не группируются с фильтрами по параметрам
      var paramKeys = _.without(this.tireAndWheelFilterKeys, 'json_ott', 'json_otr', 'json_rsgi', 'car_filter', 'by_count');
      data = _.omit(data, this.tireAndWheelFilterKeys);
      tiresAndWheelsFilters.count = this.filtered;
      Backbone.trigger('tire-wheel-filters', tiresAndWheelsFilters, paramKeys);

      return data;
    },

    /**
     * Считаем общее количество отфильтрованных товаров.
     * @param filter
     */
    setFilteredQty: function (filter) {
      var values = _.toArray(filter.values);
      if (_.some(values, 'selected')) {
        values = _.filter(values, 'selected');
      }
      this.filtered = _.sumBy(values, 'count');
    },
    /**
     * Создает дочерние фильтры
     * @param params Параметры
     */
    create: function (params) {
      var data = this.data,
        start = _.pick(data, this.start),
        middle = _.omit(_.omit(data, this.start), this.end),
        final = _.pick(data, this.end),
        index = 0,
        wrappedFilters,
        chosenFilters = params.chosenFilters;

      try {
        wrappedFilters = localStorage.wrapped_filters
          ? JSON.parse(localStorage.getItem('wrapped_filters'))
          : {};
       } catch (e) {
        wrappedFilters = {};
      }

      this.simpleSortSelected = params.simpleSortSelected;
      middle = this.restoreOriginalSort(middle);
      if (app.isNewSearchEnabled) {
        middle = this.sortByPriority(middle);
      }

      if (chosenFilters) {
        this.updateChosenFilters(chosenFilters);
      }
      index = this.createSorted(start, index, params.element, wrappedFilters);
      index = this.createSorted(middle, index, params.element, wrappedFilters);
      this.createSorted(final, index, params.element, wrappedFilters);
      Backbone.trigger('all-filters-rendered');
    },
    /**
     * Обновление модели мета-данных для рендеринга заголовков
     */
    collectTotalData: function (data) {
      var totalCount,
        selected,
        isElasticSearch = _.get(this.itemCollection, 'apiEndPoint', '').indexOf('/search/') > -1;
      /**
       * Если в информации о фильтрах есть totalCount,
       * сохраняем его в filtered, удаляем из data
       */
      if (typeof data.totalCount === 'number') {
        this.filtered = data.totalCount;
        delete data.totalCount;
      }
      if (data.category && data.category.is_question) {
        this.setFilteredQty(data.category);
      }
      if (!isElasticSearch && data.country) {
        this.setFilteredQty(data.country);
      }
      /**
       * Определяем выбрана ли какая-то категория.
       */
      selected = _.some(_.get(data, 'category.values'), 'selected');
      totalCount = _.sumBy(_.get(data, 'country.values'), 'total_count');
      /**
       * Обновляем модель мета-данных для рендеринга заголовков
       */
      this.total.set({
        count: totalCount,
        selected: !selected,
        unit: app.helpers.DeclinationHelper.format(totalCount, ['товар', 'товара', 'товаров']),
      });
    },
    /**
     * Создает уникальные id для значений фильтров и считает количество выбранных значений.
     * @param data
     */
    setUniqueIdAndCountSelectedValues: function (data) {
      var that = this;
      data = data || this.data;
      _.each(data, function (filter, filterKey) {

        // Для каждого значения фильтра создаем уникальный id
        if (filter.sub_filters) {
          var subfilterSelectedQty = 0;
          for (var subfilter in filter.sub_filters) {
            if (filter.sub_filters.hasOwnProperty(subfilter)) {
              var type = filter.type;
              var values = filter.sub_filters[subfilter].values;
              if (_.isArray(values) || !_.has(values, 'total_count')) {
                _.each(values, function (value) {
                  if (_.isObject(value)) {
                    value.uniqId = [filterKey, that._idFormatter(subfilter)].join('-');
                    if (type === 'range' || subfilter === 'price') {
                      if (value.selected && value.selected !== value.value && !subfilterSelectedQty) {
                        // Фильтр по цене показываем только если пользователь выбрал его.
                        if (subfilter === 'price') {
                          if (values.selected_by_user) {
                            subfilterSelectedQty++;
                          }
                        } else {
                          subfilterSelectedQty++;
                        }
                      }
                    } else {
                      if (value.selected) {
                        subfilterSelectedQty++;
                      }
                    }
                  }
                });
              } else {
                values.uniqId = [filterKey, that._idFormatter(subfilter)].join('-');
                if (values.selected) {
                  subfilterSelectedQty++;
                }
              }
            }
          }
          filter.selectedQty = subfilterSelectedQty;
        } else {
          var selectedQty = 0;
          if (_.isArray(filter.values) || !_.has(filter.values, 'total_count')) {
            _.each(filter.values, function (value) {
              value.uniqId = [filterKey, that._idFormatter(value.id)].join('-');
              if (value.selected) {
                selectedQty++;
              }
            });
          } else {
            filter.uniqId = [filterKey, that._idFormatter(filter.id)].join('-');
            if (filter.selected) {
              selectedQty++;
            }
          }
          filter.selectedQty = selectedQty;
        }
      });
    },
    /**
     * Ищем выбранные значения, считаем их количество и для каждого создаем уникальный id.
     * @param data
     * @returns {Array} выбранные фильтры.
     */
    getSelectedFilters: function (data) {
      data = data || this.data;
      var collectionFilters = _.keys(this.itemCollection.getFilter());
      return _.reduce(data, function (acc, value, key) {
        if (value.selectedQty || _.includes(collectionFilters, key)) {
          value.hasSelected = true;
          value.headingClass = 'active';
          value.paramName = key;
          acc.push(value);
        }
        return acc;
      }, []);
    },
    /**
     * Обновляем коллекцию с выбранными фильтрами.
     * @param chosenFilters
     * @returns {app.ChosenFilters} коллекция с выбранными фильтрами
     */
    updateChosenFilters: function (chosenFilters) {
      var that = this,
        selectedFilters = this.getSelectedFilters();

      // На ПФС на основе запроса создаем модель с описанием фильтра в коллекции выбранных
      if (app.baseFilterPageUrl && !app.filterUrlParam) {
        var title = $('.title_home').text();
        selectedFilters.unshift(new app.Model({
          class_name: 'Condition',
          name: title,
          paramName: 'condition',
        }));
        this.hasConditionFilter = true;
      }
      if (!app.isMobile) {
        var withSubfilters = _.remove(selectedFilters, function (filter) {
          return filter.sub_filters && filter.class_name !== 'CarFilter';
        });
        var flattened = withSubfilters.reduce(function (acc, cur) {
          _.forEach(cur.sub_filters, function (subfilter, key) {
            if (
              that._has_selected(subfilter)
              || key === that.chosenPopupState.sectionName
            ) {
              subfilter.paramName = key;
              acc.push(subfilter);
            }
          });
          return acc;
        }, []);
        selectedFilters = selectedFilters.concat(flattened);
        if (this.chosenPopupState.isOpen) {
          // смотрим, есть ли фильтр открытый в попапе среди выбранных
          var chosenPopupFilter = _.find(selectedFilters, {paramName: this.chosenPopupState.sectionName});
          if (!chosenPopupFilter) {
            // если не нашли, ищем его в фильтрах, пришедших в ответе сервера
            chosenPopupFilter = app.filterData[this.chosenPopupState.sectionName];
            if (chosenPopupFilter) {
              chosenPopupFilter.paramName = this.chosenPopupState.sectionName;
              selectedFilters.push(chosenPopupFilter);
            }
          }
        }
      }
      chosenFilters.reset(selectedFilters);

      return chosenFilters;
    },
    /**
     * Создаем фильтры в нужном порядке.
     * @param filters
     * @param index
     * @param element
     * @param wrapped_filters
     * @returns integer
     */
    createSorted: function (filters, index, element, wrapped_filters) {
      var maxOpenedFilterSections = 3;
      for (var i in filters) {
        if (filters.hasOwnProperty(i)) {
          var stored = wrapped_filters[i];
          if (app.features && app.features.is_new_filters_appearance) {
            filters[i].opened = true;
            filters[i].unwrapped = false;
          } else if (stored !== undefined) {
            filters[i].opened = stored;
          } else {
            filters[i].opened = index < maxOpenedFilterSections || filters[i].hasSelected || i.indexOf('spec') >= 0;
          }
          this.addItem(filters[i], element, i);
          index++;
        }
      }
      return index;
    },
    /**
     * Создает и добавляет новый фильтр
     * @param data Данные фильтра
     * @param element Элемент в который будет добавляться фильтр
     * @param key Ключ фильтра
     */
    addItem: function (data, element, key) {
      var filterObject = _.cloneDeep(data);
      filterObject.title = filterObject.name;
      filterObject.name = key;
      var itemData = {
        name: key,
        element: element,
        object: filterObject,
        unwrapped: false,
      };

      if (!_.isUndefined(this.filtersWrappedState[filterObject.name])) {
        itemData.unwrapped = this.filtersWrappedState[filterObject.name].unwrapped;
      }
      var item = this.createItem(filterObject.class_name, itemData);
      this.listenTo(item, 'change:unwrapped', this.storeUnwrappedState);
      if (item) {
        this.add([item]);
      }
    },

    /**
     * Сохраняет состояние развернутости фильтра
     * @param {Object} filterModel - обьект фильтра
     */
    storeUnwrappedState: function (filterModel) {
      this.filtersWrappedState[filterModel.get('name')] = {
        unwrapped: filterModel.get('unwrapped'),
      };
    },

    /**
     * Создает модель фильтра по типу
     * @param type Тип фильтра
     * @param data Исходные данные
     * @returns {app.Model | boolean} Модель фильтра или false
     */
    createItem: function (type, data) {
      var constructor = false;
      var filterPageFilters = {};
      if (app.baseFilterPageUrl && app.filterUrlParam) {
        filterPageFilters = Object.assign({}, app.filterUrlParam);
      }
      data.object.filterPageFilters = filterPageFilters;
      data.object.simpleSortSelected = this.simpleSortSelected;
      switch (type) {
        case 'Checkbox':
          data.object.selected = data.object.values.selected;
          constructor = new app.Filters.CheckboxFilter(data);
          break;
        case 'AggMinQty':
        case 'AggSupplyPeriod':
        case 'ColoredCheckboxList':
        case 'HasOne':
        case 'HasMany':
          constructor = new app.Filters.CheckboxList(data);
          break;
        case 'Tree':
          var categoryFilterContainer = $('#filter-category-list');
          var isNewFilterAppearance = app.features && app.features.is_new_filters_appearance;
          data.shouldCategoryFiltersWrap = this.itemCollection instanceof app.WishItems
            && isNewFilterAppearance
            && data.name === 'category';
          var categoriesQty = data.object.values ? data.object.values.length : 0;
          if (categoryFilterContainer.length) {
            if (this.itemCollection instanceof app.WishItems) {
              var isCategoriesInSearch = isNewFilterAppearance
                && this.itemCollection instanceof app.Search
                && data.name === 'category';
              if (isCategoriesInSearch) {
                data.filtersInOneRow = true;
                Backbone.trigger('found-in-categories', categoriesQty);
              }
              if (categoriesQty > 1 ) {
                data.element = categoryFilterContainer;
                constructor = new app.Filters.TreeFilter(data);
              }
            }
          } else if (categoriesQty > 1
            && (this.itemCollection instanceof app.Search
              || this.itemCollection instanceof app.WishItems)
          ) {
            // Если нет блока для фильтров категории - показывать в общем блоке (для поиска и для избранных)
            constructor = new app.Filters.TreeFilter(data);
          }
          break;
        case 'Range':
        case 'AggRange':
          constructor = new app.Filters.RangeFilter(data);
          break;
        case 'CheckboxDropDown':
        case 'DropDown':
          data.isRoot = true;
          constructor = new app.Filters.SelectFilter(data);
          break;
        case 'ParamFilter':
          constructor = new app.Filters.CompoundFilter(data);
          break;
      }
      return constructor;
    },

    /**
     * Формирует объект с параметрами фильтрации
     * @returns {Object} Параметры фильтрации
     */
    toQuery: function () {
      var obj = {};
      for (var i in this.models) {
        if (this.models.hasOwnProperty(i)) {
          obj = this.models[i].toQuery(obj);
        }
      }
      if (_.isEmpty(obj)) {
        return null;
      }
      return obj;
    },
    /**
     * Определяет одно ли значение в фильтре
     * @param filter Данные фильтра
     * @returns {boolean}
     * @private
     */
    hasOneValue: function (filter) {
      var result = false;
      if (_.includes(['AggRange', 'Range'], filter.class_name)) {
        var values = _.concat(
          _.values(filter.values.min),
          _.values(filter.values.max)
        );
        result = _.uniq(values).length === 1;
      } else {
        result = _.values(filter.values).length === 1;
      }
      return result;
    },
    /**
     * Определяет есть ли выбранные фильтры
     * @param filter Данные фильтра
     * @returns {boolean}
     * @private
     */
    _has_selected: function (filter) {
      if (filter.selected) {
        return true;
      }
      if (filter.values && filter.values.selected) {
        return true;
      }
      var values = _.values(filter.values);
      if (_.find(values, function (value) {
          if (!value) {
            return false;
          }
          return value.selected;
        })) {
        return true;
      }
      if (filter.sub_filters) {
        for (var e in filter.sub_filters) {
          if (filter.sub_filters.hasOwnProperty(e)) {
            if (filter.sub_filters[e].values.selected) {
              return true;
            }
            // Фильтр по цене показываем только если пользователь выбрал его.
            if (e === 'price' && !filter.sub_filters[e].values.selected_by_user) {
              return false;
            }
            values = _.values(filter.sub_filters[e].values);
            if (_.find(values, function (value) {
                if (!value) {
                  return false;
                }
                if (value.selected && value.value && value.selected === value.value) {
                  return false;
                }
                return value.selected;
              })) {
              return true;
            }
          }
        }
      }
      return false;
    },
    /**
     * Сортирует фильтры по приоритету.
     * @param {Object} filterObj
     * @returns {Object}
     */
    sortByPriority: function (filterObj) {
      var pairs = _.toPairs(filterObj);
      pairs = _.orderBy(pairs, function (val) {
        return val[1].priority;
      }, 'desc');
      return _.fromPairs(pairs);
    },
    /**
     * Метод для форматирования id фильтров, с целью использовать их в качестве дом селекторов.
     * @param id
     * @returns {*}
     * @private
     */
    _idFormatter: function (id) {
      if (String(id).indexOf('[') !== -1) {
        id = id.split('-').map(function (part) {
          return String(part).replace(/\D+/g, '');
        }).join('_');
      }
      return id;
    },
    /**
     * Восстанавливает оригинальную сортировку фильтров по популярности
     * @param wrappedFilters объект с фильтрами
     * @returns {{}} объект с фильтрами
     */
    restoreOriginalSort: function (wrappedFilters) {
      var sorted = {};
      var wrappedKeys = _.keys(wrappedFilters);
      var originalFormattedKeys = this.requestFilterKeys
        .map(function (key) {
          return _.replace(key, /agg_|json_/, '');
        });
      // ищем среди пришедших с сервера ключей фильтров те, что входят в обернутые фильтры,
      // и добавляем их к результату
      _.each(originalFormattedKeys, function (originalKey) {
        _.each(wrappedKeys, function (key) {
          if (_.includes(key, originalKey)) {
            sorted[key] = wrappedFilters[key];
          }
        });
      });
      // если части обернутых фильтров нет в результате - добавляем их
      var diff = _.difference(wrappedKeys, _.keys(sorted));
      if (diff.length) {
        diff.forEach(function (key) {
          sorted[key] = wrappedFilters[key];
        });
      }
      return sorted;
    },
    /**
     * Устанавливает статус попапа выбранных фильтров.
     * @param state
     * @param sectionName
     * @returns {boolean}
     */
    toggleChosenPopupState: function (state, sectionName) {
      this.chosenPopupState.isOpen = state;
      this.chosenPopupState.sectionName = sectionName;
      return state;
    },
  });

})(jQuery);

}.call(window));